export default {"src":"/_next/static/media/FinTechIcon.7b46bed5.svg","height":70,"width":130};